const finished_questionnaires = {
  'finished_questionnaires_title': "Has terminado de responder todos los cuestionarios actuales",
  'finished_questionnaires_button': "Inicio",
  'finished_questionnaire_title': "Has llegado al final del cuestionario",
}

export default finished_questionnaires;
